import styles from './styles.module.scss';
import cn from 'clsx';
import { InlineSvg } from 'components/svg';
import React, { ButtonHTMLAttributes } from 'react';

export type ButtonWithIconProps = {
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  iconPath?: string;
  iconClass?: string;
  isLoading?: boolean;
  disabled?: boolean;
  className?: string;
  btnSize?: 'sm' | 'md' | 'lg';
  btnMinWidth?: 'min-w-125px' | 'min-w-150px' | 'none';
  alignLeft?: boolean;
  btnStyle?:
    | 'primary'
    | 'secondary'
    | 'danger'
    | 'success'
    | 'light'
    | 'dark'
    | 'info'
    | 'light-primary'
    | 'light-secondary'
    | 'light-success'
    | 'light-danger'
    | 'light-dark'
    | 'light-info';
  iconOnly?: boolean;
  onClick?: (e?: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
  children: React.ReactNode;
};

/** @deprecated Use `Button` from `shared/ui/controls/button/button` instead */
export const ButtonWithIcon: React.FC<ButtonWithIconProps> = ({
  iconPath,
  type = 'button',
  iconClass = 'svg-icon-2',
  isLoading = false,
  disabled = false,
  className,
  btnSize = 'sm',
  btnStyle = 'primary',
  btnMinWidth = 'min-w-150px',
  alignLeft = false,
  iconOnly = false,
  onClick,
  children
}) => {
  return (
    <button
      type={type}
      className={cn(
        'btn',
        `btn-${btnSize}`,
        `btn-${btnStyle}`,
        btnMinWidth !== 'none' ? btnMinWidth : '',
        styles.button,
        { [styles.iconOnly]: iconOnly },
        className
      )}
      disabled={disabled || isLoading}
      onClick={(e) => {
        if (onClick) onClick(e);
      }}
    >
      {isLoading ? (
        <div className={styles.dotsLoading}>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
        </div>
      ) : (
        <div className={cn(styles.content, { [styles.alignLeft]: alignLeft })}>
          {iconPath && (
            <InlineSvg
              path={iconPath}
              className={cn(iconClass, {
                [styles.icon]: !iconOnly
              })}
            />
          )}
          {children}
        </div>
      )}
    </button>
  );
};
